import { Dispatch, Action } from 'redux'
import { TeamLogoWidgetMapDispatchReturnType } from './types/TeamLogoWidgetMapDispatchReturnType'

export const TeamLogoWidgetMapDispatch = (
  _dispatch: Dispatch<Action>
): TeamLogoWidgetMapDispatchReturnType => {
  return {}
}
